import { useEffect, useState } from "react";
import { Loading, ErrorState } from "@/components/States";
import { api, formatError } from "@/lib/api";

const Card = ({ label, value, testId }) => (
  <div data-testid={testId} className="rounded-xl border border-line bg-surface p-5">
    <p className="font-display text-2xl font-extrabold text-ink">{value}</p>
    <p className="text-xs text-ink-3">{label}</p>
  </div>
);

export default function AdminOverview() {
  const [s, setS] = useState(null);
  const [atts, setAtts] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data)).catch((e) => setErr(formatError(e)));
    api.get("/admin/attempts").then((r) => setAtts(r.data)).catch(() => {});
  }, []);
  if (err) return <ErrorState message={err} />;
  if (!s) return <Loading />;
  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <Card testId="admin-stat-users" label="Total users" value={s.users} />
        <Card testId="admin-stat-attempts" label={`Quiz attempts (${s.attempts_today} today)`} value={s.attempts} />
        <Card testId="admin-stat-avg" label="Average score" value={`${s.average_score}%`} />
        <Card testId="admin-stat-pending" label="Questions pending review" value={s.questions.pending} />
        <Card testId="admin-stat-approved" label="Approved questions" value={s.questions.approved} />
        <Card testId="admin-stat-ai-calls" label={`AI calls (${s.ai_calls_today} today)`} value={s.ai_calls} />
        <Card testId="admin-stat-failures" label="Generation failures" value={s.ai_failures} />
        <Card testId="admin-stat-cost" label={`Est. AI cost · ${s.est_tokens.toLocaleString()} tokens`} value={`$${s.est_cost_usd}`} />
      </div>
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <div className="rounded-xl border border-line bg-surface p-5">
          <h3 className="mb-3 font-bold text-ink">Recent quiz results</h3>
          {atts.length === 0 ? <p className="text-sm text-ink-3">No attempts yet.</p> : (
            <div className="max-h-80 divide-y divide-line overflow-auto text-sm">
              {atts.map((a) => <div key={a.id} className="flex justify-between gap-3 py-2"><span className="truncate">{a.user_email} · {a.subject_name}</span><span className="font-mono">{a.score}/{a.total}</span></div>)}
            </div>
          )}
        </div>
        <div className="rounded-xl border border-line bg-surface p-5">
          <h3 className="mb-3 font-bold text-ink">Recent generation failures</h3>
          {s.recent_failures.length === 0 ? <p data-testid="admin-no-failures" className="text-sm text-ink-3">No failures logged.</p> : (
            <div className="max-h-80 divide-y divide-line overflow-auto text-sm">
              {s.recent_failures.map((f) => <div key={f.id} className="py-2"><p className="font-medium capitalize">{f.kind} · {new Date(f.created_at).toLocaleString()}</p><p className="text-xs text-red-600">{f.error}</p></div>)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
